<template>
    <div class="p_t">
        <TopHead title="新闻动态"></TopHead>
        <ul class="list">
            <li v-for="item in 6" @click="detail()">
                <img src="../assets/images/pic7.png" alt="">
                <div class="lt">
                    <p>喜报，2020级冯凯润同学以564分被北京体育大学录取</p>
                    <span class="time">2021-10-12</span>
                    <span class="more">MORE+</span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        };
    },
    methods: {
        detail() {
            this.$router.push('/NewsDetail')
        },
    },
}
</script>
<style lang="scss" scoped>
    .list{
        padding: 17px 15px;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 100%;
            padding-bottom: 15px;
            border-bottom: 1PX solid #eaeaea;
            display: flex;
            justify-content: space-around;
            margin-bottom: 18px;
            img{
                width: 121px;
                height: 80px;
                display: block;
            }
            .lt{
                position: relative;
                width: 210px;
                p{
                    font-size: 14px;
                }
                .time{
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    font-size: 12px;
                }
                .more{
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    font-size: 12px;
                    color: #ff8038;
                }
            }
        }
    }
</style>
